<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="!!batchSelectedKeys?.length"
      addText="批量审批"
      :handelAdd="handelBatchApproval"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
      :ableAdd="ableBatch"
    ></search-form>
    <a-modal
      :width="isBatch ? '520px' : '900px'"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :keyboard="false"
      :class="isBatch ? '' : 'action-form-model'"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :disabled="true"
        :data="tableData"
        :idField="idField"
        :isBatch="isBatch"
        :modifyVisitTime="modifyVisitTime"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-selection="rowSelection"
      :rowKey="record => record['process_task_id']"
      :scroll="{x: 'max-content'}"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{
            codeToText(record.carApplication?.visit_area, Enum.areaType.value)
          }}
        </template>
        <template v-if="column.key === 'type_id'">
          {{
            codeToText(record.carApplication?.type_id, Enum.carModel.value)
          }}
        </template>
        <template v-if="column.key === 'type'">
          {{ codeToText(record.type, Enum.blackWhiteListType.value) }}
        </template>
        <template v-if="column.key === 'interviewee_depart_id'">
          {{
            codeToText(
              record.carApplication?.interviewee_depart_id,
              Enum.dept.value
            )
          }}
        </template>
        <template v-if="column.key === 'time_range'">
          {{ record.carApplication?.beginTime }} 至
          {{ record.carApplication?.endTime }}
        </template>
        <template v-if="column.key === 'visitor_begin_time'">
          {{ record.carApplication?.visitor_begin_time }} 至
          {{ record.carApplication?.visitor_end_time }}
        </template>
        <template v-if="column.key === 'visitArea'">
          {{
            codeToText(
              record.carApplication?.visit_area,
              Enum.areaType.value
            )
          }}
        </template>
        <template v-if="column.key === 'visitor_type'">
          {{
            codeToText(record.carApplication?.visitor_type, Enum.personVisitType.value)
          }}
        </template>
        <template v-if="column.key === 'vehicle_type_id'">
          {{ codeToText(record.carInfo?.vehicle_type_id, Enum.carModel.value) }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record.carApplication?.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'create_user_id'">
          {{
            codeToText(
              record.carApplication?.create_user_id,
              Enum.user.value
            )
          }}
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
              v-if="ableCheck && record.state === 0"
            >
              审核
            </a-button>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  name: 'CarHeavytipperApproval',
}
</script>
<script setup>
  import { ref, onMounted, onUnmounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getData } from '@/api/car_application/car_heavytipper_approval'
  import { getDetail } from '@/api/car_application/car_hazardous_application_approval'
  import action from './action'
  import searchForm from '@/components/search_form'
  import { codeToText } from '@/utils/format'
  import { message } from 'ant-design-vue'
  //初始化
  const pageName = '重型自卸货车审核'
  const idField = 'ref_id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  // 获取当前登录角色的申请园区visit_area
  const defaultVisitArea = computed(() => {
    const depart = store.getters['user/depart']
    return depart?.visit_area || ''
  })

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() => true)
  const ableCheck = computed(() =>
    !!permissionList.value?.find(item => item.code === 'heavytipperApproval:check')
  )
  const ableBatch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApplyApproval:batch')
  )
  const ableShowDept = computed(() =>
    !!permissionList.value?.find(item => item.code === 'heavytipperApproval:showDept')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'applicationNumber',
      label: '预约单号',
    },
    {
      type: 'input',
      field: 'licensePlate',
      label: '车牌号码',
    },
    {
      type: 'input',
      field: 'visitorCompany',
      label: '来访单位',
    },
    {
      type: 'input',
      field: 'intervieweeName',
      label: '被访人员姓名',
    },
    {
      type: 'input',
      field: 'intervieweePhone',
      label: '被访人员联系电话',
    },
    {
      type: 'select',
      field: 'intervieweeDepartId',
      storeOptions: 'dept',
      label: '被访机构',
      width: '190px',
      'allowClear': true,
      hidden: !ableShowDept.value
    },
    {
      type: 'input',
      field: 'applicantName',
      label: '申请人姓名',
    },
    {
      type: 'input',
      field: 'applicantPhone',
      label: '申请人联系号码',
    },
    {
      type: 'input',
      field: 'applicantIdcard',
      label: '申请人证件号码',
    },
    {
      type: 'select',
      field: 'applicationType',
      storeOptions: 'carVisitType',
      label: '申请类型',
      width: '130px',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'visitArea',
      storeOptions: 'areaType',
      defaultValue: [1, 2].includes(defaultVisitArea.value) ? defaultVisitArea.value : '',
      label: '申请园区',
      width: '130px',
      'allow-clear': true,
    },
    {
      type: 'dateRange',
      startField: 'beginTime',
      endField: 'endTime',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '时间范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setSearchCarHeavytipperApproval', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '预约单号',
      key: 'application_number',
      dataIndex: 'application_number',
      dataInObject: 'carApplication',
      align: 'left',
    },
    {
      title: '审核状态',
      dataIndex: 'approval_status',
      key: 'approval_status',
      align: 'left',
      width: 130,
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
      dataInObject: 'carApplication',
    },
    {
      title: '车型',
      dataIndex: 'vehicle_type_id',
      key: 'vehicle_type_id',
      align: 'left',
      width: 180,
    },
    {
      title: '申请人',
      key: 'applicant_name',
      dataIndex: 'applicant_name',
      align: 'left',
      dataInObject: 'carApplication',
    },
    {
      title: '申请人证件号码',
      key: 'applicant_idcard',
      dataIndex: 'applicant_idcard',
      align: 'left',
      dataInObject: 'carApplication',
      width: 130,
    },
    {
      title: '申请人联系号码',
      key: 'applicant_phone',
      dataIndex: 'applicant_phone',
      align: 'left',
      dataInObject: 'carApplication',
      width: 130,
    },
    {
      title: '申请园区',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
      // dataInObject: 'carApplication',
      width: 90,
    },
    {
      title: '申请类型',
      dataIndex: 'visitor_type',
      key: 'visitor_type',
      align: 'left',
      width: 90,
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
      dataInObject: 'carApplication',
      width: 180,
    },
    /*{
      title: '来访事由',
      dataIndex: 'visitor_content',
      key: 'visitor_content',
      align: 'left',
      dataInObject: 'carApplication',
    },*/
    {
      title: '入园时间',
      dataIndex: 'visitor_begin_time',
      key: 'visitor_begin_time',
      align: 'left',
    },
    {
      title: '被访人员',
      dataIndex: 'interviewee_name',
      key: 'interviewee_name',
      align: 'left',
      dataInObject: 'carApplication',
    },
    {
      title: '被访人联系电话',
      dataIndex: 'interviewee_phone',
      key: 'interviewee_phone',
      align: 'left',
      dataInObject: 'carApplication',
      width: 130,
    },
    {
      title: '被访机构',
      dataIndex: 'interviewee_depart_id',
      key: 'interviewee_depart_id',
      align: 'left',
      width: 180,
    },
    /*{
      title: '状态',
      dataIndex: 'state',
      key: 'state',
      align: 'left',
    },*/
    {
      title: '提交审核时间',
      dataIndex: 'submit_time',
      key: 'submit_time',
      align: 'left',
      dataInObject: 'carApplication',
      width: 130,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      // width: '120px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    batchSelectedKeys.value = []
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showEditModal(record);
      }
    }
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
      
      if (data.total > 0 && data.list.length === 0 && pagination.value.current > 1) {
        pagination.value.current -= 1;
        fetch()
      }
    })
  }
  const cachedSearchParams = computed(() => store.state.search.searchCarHeavytipperApproval)
  // 设置自动刷新
  const setupAutoRefresh = () => {
    // 清除旧定时器
    if (refreshTimer.value) {
      clearInterval(refreshTimer.value)
    }
    
    // 设置新定时器，每分钟刷新一次
    refreshTimer.value = setInterval(() => {
      // 仅在审核窗口未打开时刷新
      if (!open.value) {
        fetch()
      }
    }, 60000)
  }

  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
    setupAutoRefresh()
  })

  onUnmounted(() => {
    // 清除定时器避免内存泄漏
    if (refreshTimer.value) {
      clearInterval(refreshTimer.value)
    }
  })

  //3、审核
  const open = ref(false)
  const isEdit = ref(true)
  const editData = ref(null)
  const modifyVisitTime = ref(false)
  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      // 企业初审阶段，将申请类型、来访时间置空，强制让企业初审人员填写
      const detail = res.data
      let vehicleTypeName = detail?.vehicle_type?.name;
      if(vehicleTypeName === undefined || vehicleTypeName == null) {
        vehicleTypeName = "";
      }
      if(detail.create_time > '2026-08-05 20:00:00' &&
          detail.approval_status && detail.approval_status.includes('企业') && detail.approval_status.includes('初') &&
          !vehicleTypeName.includes('危') && !vehicleTypeName.includes('自卸货车') && !vehicleTypeName.includes('泥头车')) {
        detail.visitor_type = '';
        detail.visitor_begin_time = '';
        detail.visitor_end_time = '';
      }
      return detail
    } else {
      message.warn('获取详情失败')
    }
  }
  const showEditModal = async (data) => {
    loadingRecord.value = data
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = {
        ...detail,
        [idField]: data[idField],
        process_task_id: data.process_task_id,
      }
      modifyVisitTime.value = data.modifyVisitTime
      isBatch.value = false
      isEdit.value = true
      open.value = true
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、批量审批
  const batchSelectedKeys = ref([])
  const isBatch = ref(false)
  const refreshTimer = ref(null)
  const rowSelection = computed(() => ({
    onChange: (selectedRowKeys, selectedRows) => {
      batchSelectedKeys.value = selectedRows.map(item => item.process_task_id)
    },
    selectedRowKeys: batchSelectedKeys.value,
  }))

  function handelBatchApproval() {
    editData.value = {
      'process_task_id': batchSelectedKeys.value.toString(),
    }
    modifyVisitTime.value = false
    isBatch.value = true
    open.value = true
  }
</script>
